<template>
  <div v-if="job">
    <div class="d-flex align-items-center">
      <b> Commission(s) </b>
      <i class="fas fa-edit ml-1 link" @click="toggleModal"></i>
    </div>
    <div
      v-for="commission in job.commissions"
      :key="commission.commission_id"
      class="d-flex justify-content-between full-width"
    >
      <span class="mr-1">{{ commission.technician.full_name }}</span>
      <span>{{ formatAmount(commission) }}</span>
    </div>
    <div v-if="!job.commissions.length">--</div>
    <JobCommissionsModal
      v-if="commissionsModal"
      :job-id="job.id"
      :commissions="job.commissions"
      @save-success="$emit('save-success')"
      @hide-modal="toggleModal"
    />
  </div>
</template>

<script>
import JobCommissionsModal from "./JobCommissionsModal.vue";
export default {
  components: {
    JobCommissionsModal
  },
  props: {
    job: {
      type: Object,
      default: null
    }
  },
  emits: ["save-success"],
  data() {
    return {
      commissionsModal: false
    };
  },
  methods: {
    toggleModal() {
      this.commissionsModal = !this.commissionsModal;
    },
    formatAmount(commission) {
      return commission.percentage
        ? this.formatPercent(commission.percentage)
        : this.dollars(commission.fixed_amount_cents);
    }
  }
};
</script>

<style lang="scss" scoped></style>
